/**
 * return files picked by User
 * @param accept 
 * @param multiple 
 * @returns 
 */
export async function pickFileFromDevice(accept :string,multiple = false) :Promise<File[]>{
  return new Promise((resolve,reject)=>{
    var input = document.createElement('input');
    input.type = 'file';
    if(multiple===true){
      input.multiple = true;
    }
    input.accept = accept;
    input.addEventListener('change', e => resolve(Array.from((e.target as HTMLInputElement).files)), {once: true}); 
    input.addEventListener('cancel', e => resolve([]), {once: true});
    input.click();
  })
  
}

type DropConsumer = ()=>Promise<{
  nodes:Iterable<HTMLElement>,
  ondrop:(
    this: HTMLElement, 
    ev: DragEvent
  ) => any}>

const 
  droppableFactories :DropConsumer[] = [];

export function registerFileDropConsumer(factory :DropConsumer){
  droppableFactories.push(factory)
}

function checkDragFile(event :DragEvent){
  if(event.dataTransfer.files.item.length===0) return;
  if(document.body.classList.contains('dragging')) return;
  
  event.preventDefault();
  document.body.classList.add('dragging');
  droppableFactories.forEach(async (factory)=>{
    var {nodes,ondrop} = await factory();
    Array.from(nodes).forEach(node=>{
      node.classList.add('droppable');
      node.addEventListener('dragover',(event)=>{
        event.preventDefault();
      })
      node.addEventListener('drop',function(event){
        event.preventDefault();
        document.body.classList.remove('dragging');
        ondrop.call(this,event)
      })
    })
  })
}
document.body.addEventListener("dragover",checkDragFile)
document.body.addEventListener("drop",function(event){
  event.preventDefault()
})

registerFileDropConsumer(async function(){
  var formsWithFile = Array.from(document.body.querySelectorAll('form')).filter(form=>form.querySelector('input[type="file"]'))
  return {
    nodes:formsWithFile,
    ondrop(this: HTMLElement,event :DragEvent){
      var inputFile = this.querySelector('input[type="file"]') as HTMLInputElement
      inputFile.files = event.dataTransfer.files;
      inputFile.dispatchEvent(new Event("change"));
    }
  }
})


class DragError extends Error{};
/**
 * will apply the function to an element when starting to drag it
 * giving a dropPromiseBuilder that must be call with the potential drop target
 */
export function registerDragStart(selector : string,func : (this:HTMLElement,event:DragEvent,dropBuilder:typeof dropPromiseBuilder)=>void){
  document.body.addEventListener('dragstart',async function(event){
    var dragged = event.target as HTMLElement;
    if(dragged.matches && dragged.matches(selector)){
      try{
        await func.call(dragged,event, dropPromiseBuilder)
      }catch(e){
        if(e instanceof DragError){
          console.log(e.message)
        }else{
          throw e;
        }
      }
    }  
  })

}
/**
 * Create a promise of drop of dragging in all dropTargets
 * It create/clean all event listener
 * @param dragging 
 * @param dropTargets 
 * @returns 
 */
export async function dropPromiseBuilder(dragging :HTMLElement,dropTargets :Iterable<HTMLElement>, excludeDropParent=true):Promise<DragEvent>{
  document.body.classList.add("dragging")
  
  //clean droptarget keeping only those who do not contains dragging
  if(excludeDropParent){
    dropTargets = Array.from(dropTargets).filter(dropTarget=>!dropTarget.contains(dragging));
  }
  
  function prevent(this:HTMLElement, event:DragEvent){
    event.preventDefault();
  }
  //important must have css like .droppable>* : pointer-events: none; 
  function enter(this:HTMLElement, event :DragEvent){
    this.classList.add('droppable-active')
  }
  function leave(this:HTMLElement, event :DragEvent){
    this.classList.remove('droppable-active')
  }
  

  var 
    timeout;
  return new Promise<DragEvent>((resolve,reject)=>{
    document.body.addEventListener("dragend",()=>reject(new DragError("Drag aborted")))
    Array.from(dropTargets).forEach(dropTarget=>{
      dropTarget.addEventListener("drop",resolve, {once:true})
      dropTarget.addEventListener("dragover",prevent)
      dropTarget.addEventListener("dragenter",enter)
      dropTarget.addEventListener("dragleave",leave)
      dropTarget.classList.add("droppable")
    })
    timeout = setTimeout(()=>reject(new DragError("Drag timeout done")),10000)

  }).finally(()=>{
    clearTimeout(timeout)
    Array.from(dropTargets).forEach(dropTarget=>{
      dropTarget.removeEventListener("dragover",prevent)
      dropTarget.removeEventListener("dragenter",enter)
      dropTarget.removeEventListener("dragleave",leave)
      dropTarget.classList.remove("droppable")
      dropTarget.classList.remove("droppable-active")
    })
    document.body.classList.remove("dragging")
    
  })
  
}